import { render, staticRenderFns } from "./BundleProductAddNew.vue?vue&type=template&id=7407de94&"
import script from "./BundleProductAddNew.vue?vue&type=script&lang=js&"
export * from "./BundleProductAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports